import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_BENUTZER_AKTIVIEREN_ADMIN = '[BenutzerverwaltungModul] PostBenutzerAktivierenAdmin laden';
export const POST_BENUTZER_AKTIVIEREN_ADMIN_AUSFUEHREN = '[BenutzerverwaltungModul] PostBenutzerAktivierenAdmin ausführen';
export const POST_BENUTZER_AKTIVIEREN_ADMIN_ERFOLGREICH = '[BenutzerverwaltungModul] PostBenutzerAktivierenAdmin laden erfolgreich';
export const POST_BENUTZER_AKTIVIEREN_ADMIN_FEHLER = '[BenutzerverwaltungModul] PostBenutzerAktivierenAdmin Ladefehler';
export const POST_BENUTZER_AKTIVIEREN_ADMIN_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostBenutzerAktivierenAdmin nicht ausgeführt (evtl. Offline)';


export class PostBenutzerAktivierenAdminAction implements Action {
    readonly type = POST_BENUTZER_AKTIVIEREN_ADMIN;
        constructor(public benutzerAktivierenRequest: api.BenutzerAktivierenRequest, public optPayload: any = null) {}
    }
export class PostBenutzerAktivierenAdminAusfuehrenAction implements Action {
    readonly type = POST_BENUTZER_AKTIVIEREN_ADMIN_AUSFUEHREN;
        constructor(public benutzerAktivierenRequest: api.BenutzerAktivierenRequest, public optPayload: any = null) {}
    }
export class PostBenutzerAktivierenAdminErfolgreichAction implements Action {
    readonly type = POST_BENUTZER_AKTIVIEREN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.BenutzerIdentifier, public benutzerAktivierenRequest: api.BenutzerAktivierenRequest, public optPayload: any = null) {}
    }
export class PostBenutzerAktivierenAdminFehlerAction implements Action {
    readonly type = POST_BENUTZER_AKTIVIEREN_ADMIN_FEHLER;
        constructor(public payload: any, public benutzerAktivierenRequest: api.BenutzerAktivierenRequest, public optPayload: any = null) {}
    }
export class PostBenutzerAktivierenAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_BENUTZER_AKTIVIEREN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandBenutzerAktivierenAdminActions =
    PostBenutzerAktivierenAdminAction
    | PostBenutzerAktivierenAdminAusfuehrenAction
    | PostBenutzerAktivierenAdminErfolgreichAction
    | PostBenutzerAktivierenAdminFehlerAction
    | PostBenutzerAktivierenAdminNichtAusgefuehrtAction
    ;
